export const CONTEXT_TYPE = {
  individual: 1,
  pedigree: 2,
};